import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-top__menu-container" }
const _hoisted_2 = { class: "p-menu" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "c-menuitem__img" }, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "c-menuitem__ttl" }, "会員情報", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "c-menuitem__img" }, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "c-menuitem__ttl" }, "パスワード変更", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "c-menuitem__img" }, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "c-menuitem__ttl" }, "メールアドレス変更", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "c-menuitem__img" }, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "c-menuitem__ttl" }, "退会", -1)
const _hoisted_11 = { class: "p-top__btn-container" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "マイページはこちら", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: { name: 'Profile' },
          class: _normalizeClass(["c-menuitem c-menuitem--profile js-animation_fadeUp ts-00", { 'is-on': _ctx.isOnRef }])
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          to: { name: 'ChangePassword' },
          class: _normalizeClass(["c-menuitem c-menuitem--password js-animation_fadeUp ts-01", { 'is-on': _ctx.isOnRef }])
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          to: { name: 'ChangeEmail' },
          class: _normalizeClass(["c-menuitem c-menuitem--email js-animation_fadeUp ts-02", { 'is-on': _ctx.isOnRef }])
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _hoisted_8
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          to: { name: 'Withdrawal' },
          class: _normalizeClass(["c-menuitem c-menuitem--delete js-animation_fadeUp ts-03", { 'is-on': _ctx.isOnRef }])
        }, {
          default: _withCtx(() => [
            _hoisted_9,
            _hoisted_10
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_router_link, {
        to: { name: 'MypageTop' },
        class: "c-btn c-btn--color"
      }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      })
    ])
  ], 64))
}